// Import all ts files here
import '../styles/index.scss';
import './templates/cart';
import { docReady } from './helpers/docReady';
import { splitImages } from './sections/split-images-with-text';
import { carousel } from './sections/carousel';
docReady(() => {
    // Initiate JS
    splitImages();
    carousel();
});
